import { parsePhoneNumberFromString } from "libphonenumber-js";

export function toE164(value, countryIso2) {
  const raw = String(value || "").trim();
  if (!raw) return null;

  const iso2 = countryIso2 ? String(countryIso2).toUpperCase() : undefined;

  const phone = raw.startsWith("+")
    ? parsePhoneNumberFromString(raw)
    : parsePhoneNumberFromString(raw, iso2);

  if (!phone || !phone.isValid()) return null;
  return phone.number; // E.164, e.g. +491234567890
}

export function isValidPhone(value, countryIso2) {
  return Boolean(toE164(value, countryIso2));
}

export function phoneError(value, countryIso2) {
  const raw = String(value || "").trim();
  if (!raw) return "Phone number is required";
  if (!isValidPhone(raw, countryIso2)) return "Please enter a valid phone number.";
  return null;
}
